const normalizeId = (id) => {
  if (!id) return "";
  if (typeof id === "string") return id;
  if (typeof id === "object" && id.$oid) return String(id.$oid);
  return String(id);
};

const normalizeCoordinates = (coordinates) => {
  const lat = Number(coordinates?.lat);
  const lng = Number(coordinates?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
};

export const buildLiveTrackingData = (visitRow, duty) => {
  const visit = visitRow?.parentVisit || visitRow;
  if (!visit) return null;

  const nameInfo =
    duty?.attendedBy?.userID?.personalInfo?.basicInfo?.nameInfo || {};
  const hcpName =
    `${nameInfo.title ? nameInfo.title + " " : ""}${nameInfo.fullName || ""}`.trim() ||
    visit?.specialistInfo?.name ||
    visit?.dutyStaff?.name ||
    "HCP";

  return {
    visitID: normalizeId(visit._id),
    dutyID: normalizeId(duty?._id),
    patientLocation: visit?.visitInfo?.addressInfo?.coordinates || null,
    initialHCPLocation: normalizeCoordinates(
      duty?.currentLocation?.coords || duty?.currentLocation,
    ),
    hcpName,
    hcpRole: duty?.attendedBy?.role || visit?.specialistInfo?.role || "HCP",
  };
};
